/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PhysicianScheduleBlockDetailAliases {
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DELETE_SCHEDULE_BLOCK_ACTION = 'delete-schedule-block-action',
  NEW_SCHEDULE_BLOCK_ACTION = 'new-schedule-block-action',
  PHYSICIAN_FINAL_DATA_FIELD = 'physician-final-data-field',
  PHYSICIAN_INITIAL_DATE_FIELD = 'physician-initial-date-field',
  PHYSICIAN_SCHEDULE_BLOCK_DAY_WEEK_AUTOCOMPLETE = 'physician-schedule-block-day-week-autocomplete',
  PHYSICIAN_SCHEDULE_BLOCK_DAY_WEEK_FETCH = 'physician-schedule-block-day-week-fetch',
  PHYSICIAN_SCHEDULE_BLOCK_DAY_WEEK_FIELD = 'physician-schedule-block-day-week-field',
  PHYSICIAN_SCHEDULE_BLOCK_DAY_WEEK_MAPPER = 'physician-schedule-block-day-week-mapper',
  PHYSICIAN_SCHEDULE_BLOCK_DAY_WEEK_TEXT = 'physician-schedule-block-day-week-text',
  PHYSICIAN_SCHEDULE_BLOCK_DETAIL_FORM = 'physician-schedule-block-detail-form',
  PHYSICIAN_SCHEDULE_BLOCK_DETAIL_LAYOUT = 'physician-schedule-block-detail-layout',
  PHYSICIAN_SCHEDULE_BLOCK_DETAIL_PANEL = 'physician-schedule-block-detail-panel',
  PHYSICIAN_SCHEDULE_BLOCK_ESTABLISHMENT_AUTOCOMPLETE = 'physician-schedule-block-establishment-autocomplete',
  PHYSICIAN_SCHEDULE_BLOCK_ESTABLISHMENT_FETCH = 'physician-schedule-block-establishment-fetch',
  PHYSICIAN_SCHEDULE_BLOCK_ESTABLISHMENT_FIELD = 'physician-schedule-block-establishment-field',
  PHYSICIAN_SCHEDULE_BLOCK_ESTABLISHMENT_MAPPER = 'physician-schedule-block-establishment-mapper',
  PHYSICIAN_SCHEDULE_BLOCK_ESTABLISHMENT_TEXT = 'physician-schedule-block-establishment-text',
  PHYSICIAN_SCHEDULE_BLOCK_SCHEDULE_CODE_AUTOCOMPLETE = 'physician-schedule-block-schedule-code-autocomplete',
  PHYSICIAN_SCHEDULE_BLOCK_SCHEDULE_CODE_FETCH = 'physician-schedule-block-schedule-code-fetch',
  PHYSICIAN_SCHEDULE_BLOCK_SCHEDULE_CODE_FIELD = 'physician-schedule-block-schedule-code-field',
  PHYSICIAN_SCHEDULE_BLOCK_SCHEDULE_CODE_MAPPER = 'physician-schedule-block-schedule-code-mapper',
  PHYSICIAN_SCHEDULE_BLOCK_SCHEDULE_CODE_TEXT = 'physician-schedule-block-schedule-code-text',
  PHYSICIAN_SCHEDULE_DESCRIPTION_FIELD = 'physician-schedule-description-field',
  PHYSICIAN_SCHEDULE_DESCRIPTION_TEXT_AREA = 'physician-schedule-description-text-area',
  PHYSICIAN_SCHEDULE_FINAL_DATA_FIELD = 'physician-schedule-final-data-field',
  PHYSICIAN_SCHEDULE_FINAL_TIME_DATE_PICKER = 'physician-schedule-final-time-date-picker',
  PHYSICIAN_SCHEDULE_FINAL_TIME_FIELD = 'physician-schedule-final-time-field',
  PHYSICIAN_SCHEDULE_INITIAL_DATE_FIELD = 'physician-schedule-initial-date-field',
  PHYSICIAN_SCHEDULE_INITIAL_TIME_DATE_PICKER = 'physician-schedule-initial-time-date-picker',
  PHYSICIAN_SCHEDULE_INITIAL_TIME_FIELD = 'physician-schedule-initial-time-field',
  PHYSICIAN_SCHEDULE_REASON_AUTOCOMPLETE = 'physician-schedule-reason-autocomplete',
  PHYSICIAN_SCHEDULE_REASON_FETCH = 'physician-schedule-reason-fetch',
  PHYSICIAN_SCHEDULE_REASON_FIELD = 'physician-schedule-reason-field',
  PHYSICIAN_SCHEDULE_REASON_MAPPER = 'physician-schedule-reason-mapper',
  PHYSICIAN_SCHEDULE_REASON_TEXT = 'physician-schedule-reason-text',
}
export { PhysicianScheduleBlockDetailAliases };
